import { STATIC_ASSETS_URL } from "common/context/constants"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"

import "./style.scss"

// eslint-disable-next-line @typescript-eslint/no-empty-function
const ShortAccess = ({ body, close = () => {} }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { title = "", subtitle = "", link = "" } = body
  const history = useHistory()

  const handleClick = () => {
    close()
    history.push(link)
  }

  return (
    <div
      className='items-center mg-space d-flex'
      onClick={handleClick}
    >
      <div className='content-ocr'>
        <div>
          <img
            width='118.39'
            height='117.62'
            src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/img-escanear-facturas-pdf.svg`}
            alt='img-escanear-facturas-pdf.svg'
          />
        </div>

        <div className='ml-5 mr-5 text-left d-flex flex-column justify-content-center align-items-start'>
          <div className='text-orange'>{title}</div>
          <div>{subtitle}</div>
        </div>

        <div className='d-flex justify-content-end align-items-center'>
          <Button
            className='button start-button'
            onClick={handleClick}
          >
            {t("nav.directAccess.startButton")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ShortAccess
